export default "__VITE_ASSET__UaBM2ZoZ__"